import { api } from "@/client/api"

export default {
    restartFlow() {
        return api.post(`/flow/restart`)
    },

    startFlowWithToken(token) {
        return api.post(`/flow/start/tokens/${encodeURIComponent(token)}`)
    },

    startFlowWithEntityKey(entityKey, request = undefined) {
        return api.post(`/flow/start/entity-keys/${encodeURIComponent(entityKey)}`, request)
    },

    startFlowWithDefaultEntityKey(request = undefined) {
        return api.post("/flow/start", request)
    },

    finishCompleted() {
        return api.post(`/flow/finish/completed`)
    },

    finishCanceled() {
        return api.post(`/flow/finish/canceled`)
    },

    finishPending() {
        return api.post(`/flow/finish/pending`)
    },

    finishTimeout() {
        return api.post(`/flow/finish/timeout`)
    },
}
